/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import { IconButton, Stack, TextField } from '@mui/material'
import Close from '@mui/icons-material/Close'
import Search from '@mui/icons-material/Search'
import { useAsyncDebounce } from 'react-table'
import { useState } from 'react'

interface Props {
  setShowSearch: (value: boolean) => void
  globalFilter: string
  setGlobalFilter: (filterValue: any) => void
}

export default function GlobalSearchFilter({ globalFilter, setGlobalFilter, setShowSearch }: Props) {
  const [value, setValue] = useState(globalFilter)
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined)
  }, 300)

  return (
    <Stack
      data-testid="globalSearchFilter"
      width="100%"
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Search />
      <TextField
        value={value || ''}
        onChange={(evt) => {
          setValue(evt.target.value)
          onChange(evt.target.value)
        }}
        fullWidth
        variant="standard"
        autoFocus
      />
      <IconButton
        onClick={() => {
          setGlobalFilter(null)
          setShowSearch(false)
        }}
      >
        <Close />
      </IconButton>
    </Stack>
  )
}
